import { useContext } from 'react'
import { useFirestoreGeneral } from '../firebase/useFirestore'
import { TemplateDataContext } from '../components/liveReport/reportBuilder2/context/TemplateDataContext'
import isTemplateMode from '../components/liveReport/reportBuilder2/widgets/_shared/isTemplateMode'

/**
 * De naam van het effect dat een vragenlijstveld meet.
 *
 * Meetstandaardvragen (MSI) hebben zelf een lege of generieke `Question` — de
 * echte naam staat op het gekoppelde `OutputEffects`-document. Elk scherm dat
 * zo'n vraag toont heeft dezelfde opzoeking nodig; dit is die opzoeking, één
 * keer, zodat de kaart en de grafiekkop niet uit elkaar lopen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 * AI-CONTEXT: See docs/pitfalls.md#state-firestore-lookup-empty-in-template-mode
 *
 * @param {string | string[]} [effectId] - `EffectId` van het veld (een reeks
 *   `OutputEffects`-ID's, of één ID).
 * @returns {string} De effectnaam, of '' zolang er geen effect is gevonden.
 */
const useMsiEffectTitle = (effectId) => {
    const id = Array.isArray(effectId) ? effectId[0] : effectId
    // In een template hoort het effect bij de Stichting Template, niet bij de
    // organisatie van wie kijkt (docs/features/livereport-templates-deelnemer.md, T3).
    // Ook aan de url: in de templateviewer staat de providervlag pas aan als het rapport geladen is.
    const { isTemplate: templateFlag, templateData } = useContext(TemplateDataContext)
    const isTemplate = templateFlag || isTemplateMode()
    const effects = useFirestoreGeneral('OutputEffects', 'ID', isTemplate ? '' : (id || ''))
    const effect = isTemplate
        ? (templateData?.data?.effects?.effects || []).find(e => e.ID === id) || null
        : (Array.isArray(effects) && effects.length > 0 ? effects[0] : null)

    return effect && effect.Effect ? effect.Effect : ''
}

export default useMsiEffectTitle
